export default __webpack_public_path__ + "static/media/txt_series2.e444482a.svg";